<template>
  <li
    class="relative text-gray-600 ring-offset-2 ring-transparent hover:bg-gray-50"
    :class="isHoveringOverBlock && '!ring-offset-3 ring-2 !ring-rose-400 z-10'"

    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <svg :class="!loading && hovering ? 'opacity-100' : 'opacity-0'" class="drag-handle transition absolute top-1/2 -translate-y-1/2 left-0 -translate-x-full cursor-move active:cursor-grabbing" width="24" height="24">
      <path fill="currentColor" d="M14.5 15.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0114.5 15.5zm-5 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 019.5 15.5zm5-5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0114.5 10.5zm-5 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 019.5 10.5zm5-5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0114.5 5.5zm-5 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 019.5 5.5z"></path>
    </svg>

    <BlockConfiguration :disabled="loading" v-bind="$props">
      <div class="p-2 flex justify-between">
        <span>
          <span class="w-72 inline-block truncate flex items-center space-x-2" :class="lastHover === id && 'text-rose-700'">
            <slot></slot>
            <transition name="fade">
              <svg v-if="!loading && hovering" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </transition>
          </span>
          <div v-if="differentColors.length" class="space-x-1">
            <span
              v-for="(color, index) in differentColors"
              :key="color + index"

              class="h-4 w-4 rounded-full inline-block"
              :style="{backgroundColor: color}"
            ></span>
          </div>
          <div v-if="states" class="space-x-2">
            <span
              v-for="(state, index) in states"
              class="p-1 px-2 text-xs border border-gray-100 hover:bg-gray-50 duration-150 cursor-pointer rounded"
              :class="activeState === state && '!text-white !bg-gray-800 !border-gray-800'"
              :key="index"
              @click="setState(state)"
            >
              {{ state }}
            </span>
          </div>
        </span>
      </div>
    </BlockConfiguration>

    <!--    <BlockConfiguration v-if="!loading" v-bind="$props">
          <span class="text-gray-500 p-1 border border-gray-200 rounded-lg cursor-pointer flex hover:bg-gray-50">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
            </svg>
          </span>
        </BlockConfiguration>-->
  </li>
</template>

<script>

import BlockConfiguration from '../../BlockConfiguration/BlockConfiguration.vue'

import { mapGetters } from 'vuex'

export default {
  props: ['loading', 'title', 'id', 'role', 'config', 'content', 'first', 'states'],
  data() {
    return {
      hovering: false,
    }
  },
  components: {
    BlockConfiguration,
  },
  methods: {
    setState(state) {
      this.$store.dispatch("editor/setState", {blockId: this.id, blockState: state})
    },
  },
  computed: {
    ...mapGetters({
      editorConfig: 'editor/config',
      blockHover: 'editor/blockHover',
      lastHover: 'editor/lastHover',
      currentStates: 'editor/states',
    }),

    isHoveringOverBlock() {
      return this.id === this.blockHover
    },
    activeState() {
      return this.currentStates[this.id] || this.states && this.states[0]
    },
    differentColors() {
      try {
        const colors = this.editorConfig.tailwindConfig.extend.colors
        const keys = Object.keys(colors)
        const blockId = this.id

        return keys.filter(id => id.includes(blockId)).reduce((all, key) => ([
          ...all,
          ...(typeof colors[key] === 'string' ? [colors[key]] : Object.values(colors[key])),
        ]), []).filter(color => color)
      } catch (err) {
        return []
      }
    },
  },
}

</script>
